export const extractIdFromUrl = (str: string) => {
  if (!str) return '';
  return str.split('__').pop() || '';
};
